import React from "react";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import { motion } from "framer-motion";

import "react-vertical-timeline-component/style.min.css";

import { styles } from "../styles";
import { experiences } from "../Constants";
import { SectionWrapper } from "../hoc";
import { textVariant } from "../utils/motion";

const TimelineCard = ({ item }) => {
  return (
    <VerticalTimelineElement
      className="vertical-timeline-element--experience group"
      contentStyle={{
        background: "var(--bg-card)",
        color: "var(--text-primary)",
        backdropFilter: "blur(16px)",
        border: "1px solid var(--border-subtle)",
        boxShadow: "0 4px 24px rgba(0, 0, 0, 0.1)",
      }}
      contentArrowStyle={{ borderRight: "7px solid var(--border-subtle)" }}
      date={item.date}
      iconStyle={{ background: item.iconBg }}
      icon={
        <div className='flex items-center justify-center w-full h-full'>
          <img
            src={item.icon}
            alt={item.company_name}
            className='w-[60%] h-[60%] object-contain'
          />
        </div>
      }
    >
      <div className="flex justify-between items-start gap-4">
        <div>
          <h3 className='text-[24px] font-bold group-hover:text-indigo-400 transition-colors duration-300' style={{ color: "var(--text-primary)" }}>{item.title}</h3>
          <p
            className='text-[16px] font-semibold'
            style={{ margin: 0, color: "var(--color-indigo-light)" }}
          >
            {item.company_name}
          </p>
        </div>
        {item.type && (
          <span className={`px-3 py-1 rounded-full text-xs font-semibold whitespace-nowrap ${item.type === 'Work' ? 'bg-cyan-500/10 text-cyan-500 border border-cyan-500/20' : 'bg-purple-500/10 text-purple-500 border border-purple-500/20'}`}>
            {item.type}
          </span>
        )}
      </div>

      <ul className='mt-5 ml-5 space-y-2 list-disc mb-4'>
        {item.points && item.points.map((point, index) => (
          <li
            key={`item-point-${index}`}
            className='text-[14px] pl-1 tracking-wider'
            style={{ color: "var(--text-secondary)" }}
          >
            {point}
          </li>
        ))}
      </ul>

      {item.tags && (
        <div className='flex flex-wrap gap-2 mt-4 pt-4 border-t border-indigo-500/10'>
          {item.tags.map((tag, index) => (
            <span
              key={`tag-${index}`}
              className='px-2.5 py-1 text-[11px] rounded-md transition-colors duration-300 hover:bg-indigo-500/20'
              style={{ background: 'rgba(79, 70, 229, 0.1)', color: 'var(--color-indigo-light)', border: '1px solid rgba(79, 70, 229, 0.2)' }}
            >
              #{tag}
            </span>
          ))}
        </div>
      )}
    </VerticalTimelineElement>
  );
};

const Experience = () => {
  return (
    <section id="Experience" aria-label="Work Experience">
      <motion.div variants={textVariant()}>
        <div className="text-center lg:mb-8 mb-2 px-[5%]">
          <div className="relative inline-block group">
            <h2
              className="text-4xl md:text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#6366f1] to-[#a855f7]"
              data-aos="zoom-in-up"
              data-aos-duration="600"
            >
              Work Experience
            </h2>
          </div>
        </div>
      </motion.div>

      <div className='flex flex-col mt-20'>
        <VerticalTimeline>
          {experiences.map((item, index) => (
            <TimelineCard
              key={`experience-${index}`}
              item={item}
            />
          ))}
        </VerticalTimeline>
      </div>
    </section>
  );
};

export default SectionWrapper(Experience, "work");
